"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeetingsReportCancellationStatus;
(function (MeetingsReportCancellationStatus) {
    MeetingsReportCancellationStatus[MeetingsReportCancellationStatus["Active"] = 1] = "Active";
    MeetingsReportCancellationStatus[MeetingsReportCancellationStatus["CanceledBeforeEvent"] = 2] = "CanceledBeforeEvent";
    MeetingsReportCancellationStatus[MeetingsReportCancellationStatus["CanceledDuringEvent"] = 3] = "CanceledDuringEvent";
})(MeetingsReportCancellationStatus || (MeetingsReportCancellationStatus = {}));
exports.default = MeetingsReportCancellationStatus;
